import { api } from './';

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

export const inserirBanner = async (params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.post(`/conteudo/inserirPublicacao`, params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao inserir banner';
    throw new Error(errorMessage);
  }
};

export const editarBanner = async (id: number, params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.put(`/conteudo/editar/${id}`, params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao editar banner';
    throw new Error(errorMessage);
  }
};

export const listarBanner = async (
  codTipoPublicacao: number,
  pagina: number,
  tamanhoPagina: number,
  nomePublicacao?: string,
  situacao?: number,
  datPublicacaoInicio?: string,
  datPublicacaoFim?: string,
  datDespublicarInicio?: string,
  datDespublicarFim?: string
) => {
  const params = new URLSearchParams()
  params.append('codTipoPublicacao', codTipoPublicacao.toString())
  params.append('pagina', pagina.toString())
  params.append('tamanhoPagina', tamanhoPagina.toString())

  if (nomePublicacao) params.append('nomePublicacao', nomePublicacao)
    if (situacao !== undefined) 
      params.append('codSituacaoPubli', situacao.toString());
    
  if (datPublicacaoInicio)
    params.append('datPublicacaoInicio', datPublicacaoInicio)
  if (datPublicacaoFim) params.append('datPublicacaoFim', datPublicacaoFim)
  if (datDespublicarInicio)
    params.append('datDespublicarInicio', datDespublicarInicio)
  if (datDespublicarFim) params.append('datDespublicarFim', datDespublicarFim)

  const response = await api.get(`/conteudo/listar?${params.toString()}`)
  return response.data
}

export const obterListaFiltroSituacao = async () => {
  try {
    const response = await api.get(`/sitPublicacao`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter lista de situações';
    throw new Error(errorMessage);
  }
};

export const obterBanner = async (id: any) => {
  try {
    const response = await api.get(`/conteudo/obter/${id}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter banner';
    throw new Error(errorMessage);
  }
};

export const deletarRelacionamentoPagina = async (seqConteudo: number, seqPagina: number ) => {
  try {
    const response = await api.delete(`/conteudo/deletarRelacionamento?seqConteudo=${seqConteudo}&seqPagina=${seqPagina}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao deletar relacionamento de página';
    throw new Error(errorMessage);
  }
};

export const paginasAtivas = async () => {
  try {
    const response = await api.get('/paginas/ativas');
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao listar páginas ativas';
    throw new Error(errorMessage);
  }
};

export const validarOrdemDisponiveis = async (seqPagina: number) => {
  try {
    const response = await api.get(`/paginas/relacionamentos/${seqPagina}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao validar ordem disponíveis';
    throw new Error(errorMessage);
  }
};

export const inserirBannerNoCdn = async (params: FormData) => {
  try {
    const response = await api.post('/files/upload', params, {
      headers: {
        'Accept': '*/*'
      },
    });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const editarBannerNoCdn = async (params: FormData) => {
  try {
    const response = await api.put('/files/update', params, {
      headers: {
        'Accept': '*/*'
      },
    });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const deletarBannerNoCdn = async (nomeArquivo: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.delete(`/files/${nomeArquivo}`, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const deletarBanner = async (id: any) => {
  try {
    const headers = {
      'Accept': '*/*'
    };
    const response = await api.delete(`/conteudo/${id}`, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const listarExecutores = async () => {
  try {
    const response = await api.get('/usuarios/listarExecutores');
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao listar usuários para aprovação';
    throw new Error(errorMessage);
  }
};